module.exports = __webpack_public_path__ + "static/media/app.e0b35a9e.jpg";